export const fileUploaderConstants = {
  profilePic: 'profile-pic'
}

export const fileUploaderTypes = {
  default: 'DEFAULT',
  profile: 'PROFILE'
}

export const IMAGE = 'IMAGE'

export const EXPIRED_TOKEN = 'ExpiredToken'

export const BANK_DETAILS_BUCKET_PATH = 'bank-details'

export const PAN_CARD_DETAILS_BUCKET_PATH = 'pan-card-details'

export const GST_DETAILS_BUCKET_PATH = 'gst-details'

export const fileUploaderBucketPaths = {
  bankDetails: BANK_DETAILS_BUCKET_PATH,
  panCardDetails: PAN_CARD_DETAILS_BUCKET_PATH,
  gstDetails: GST_DETAILS_BUCKET_PATH
}
